<template>
    <div class="flex lg:flex-row flex-col mx-auto w-full p-12 lg:p-24 pb-12 pb-10 lg:pb-18 text-left gap-24"
        style="max-width: 1400px;">
        <!-- KIRCHENBLATT -->
        <div class="w-full lg:w-1/2 flex flex-col" id="butterfly">
            <h2 class="font-written text-4xl">Der Schmetterling</h2>
            <p class="text-lg text-gray-500 mt-3">Kirchenblatt</p>

            <div class="flex flex-col gap-2 mt-5">
                <p class="text-sm italic mt-5" v-if="files.length == 0">Daten konnten nicht geladen werden, bitte
                    versuche es später erneut.</p>
                <template v-for="i in files.slice(0, currentFiles)" :key="i" v-if="files.length > 0">
                    <div class="w-full rounded-2xl relative overflow-hidden bg-white flex gap-2"
                        style="box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);">
                        <div class="bg-card-dark w-28 flex shrink-0 pb-2">
                            <img src="@/assets/icons/butterfly.png" alt="Schmetterling Icon" class="invert h-14 m-auto" draggable="false">
                        </div>
                        <div class="p-3 flex-auto flex flex-col gap-2">
                            <div class="flex flex-col">
                                <p class="">{{ i.Name }}</p>
                                <p class="text-xs text-gray-500">Ausgabe</p>
                            </div>
                            <div class="flex-auto flex gap-1 sm:gap-2 shrink-0 ml-auto">
                                <a class="flex items-center gap-2 text-sm hover:bg-gray-300 py-2 px-3 rounded-lg overflow-hidden cursor-pointer"
                                    :href="CMS_URL + '/assets/' + i.Datei + '/Schmetterling.pdf'" target="_blank">
                                    <svg class="size-5 mt-0.5" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                        viewBox="0 0 24 24">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M13.213 9.787a3.391 3.391 0 0 0-4.795 0l-3.425 3.426a3.39 3.39 0 0 0 4.795 4.794l.321-.304m-.321-4.49a3.39 3.39 0 0 0 4.795 0l3.424-3.426a3.39 3.39 0 0 0-4.794-4.795l-1.028.961" />
                                    </svg>
                                    <span class="hidden min-[400px]:block">Lesen</span></a>
                                <!-- <a
                                    class="flex items-center gap-2 text-sm hover:bg-gray-300 py-2 px-3 rounded-2xl overflow-hidden cursor-pointer"><img
                                        src="@/assets/icons/downloads.png" class="w-4 mb-1" draggable="false"
                                        href=""><span class="hidden sm:block">Herunterladen</span></a> -->
                            </div>
                        </div>
                    </div>
                </template>
            </div>

            <button class="mx-auto mt-5 hover:text-primary-default hover:underline" v-if="files.length > 5"
                @click="currentFiles < files.length ? currentFiles += 3 : currentFiles = 5;">{{ currentFiles >=
                    files.length ?
                    'Weniger anzeigen' : 'Mehr anzeigen' }}</button>
        </div>

        <!-- KONTAKT -->
        <div class="max-w-[420px] lg:max-w-[999px] lg:flex-auto lg:w-auto flex flex-col items-center" id="contact">
            <div class="flex flex-col w-full">
                <h2 class="font-written text-4xl">Kontakt</h2>

                <p class="text-lg text-gray-500 mt-3">Pfarrer, Bankverbindungen</p>

                <div class="mt-4 flex flex-col w-full p-6 rounded-2xl bg-white"
                    style="box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);">
                    <div>
                        <p class="font-bold">Hans-Ulrich Bayer (Pfarrer)</p>
                        <div class="flex flex-col gap-1 mt-3">
                            <p class="flex"><span class="w-14 font-bold mr-8">Mobil</span> <a href="tel:017670817415"
                                    class="hover:underline">0176 / 70817415</a></p>
                            <p class="flex"><span class="w-14 font-bold mr-8 shrink-0">E-Mail</span> <a
                                    href="mailto:hans-ulrich.bayer@ekmd.de"
                                    class="hover:underline break-words overflow-hidden">hans-ulrich.bayer@ekmd.de</a>
                            </p>
                        </div>
                    </div>

                    <div class="mt-8">
                        <p class="font-bold">Pfarreramt Rastenberg</p>
                        <div class="flex flex-col gap-1 mt-3">
                            <p class="flex"><span class="w-14 font-bold mr-8">Adresse</span> Lossaer Str. 8, <br>99636
                                Rastenberg
                            </p>
                            <p class="flex"><span class="w-14 font-bold mr-8">Telefon</span> <a href="tel:03637780324"
                                    class="hover:underline">036377 / 80324</a></p>
                        </div>
                    </div>

                    <div class="mt-8">
                        <p class="font-bold">Öffnungszeiten</p>
                        <div class="flex flex-col gap-1 mt-3">
                            <p class="flex"><span class="w-14 font-bold mr-8">Dienstag</span> 9.00 - 15.00 Uhr</p>
                        </div>
                    </div>

                    <button
                        class="mt-8 max-w-48 p-2.5 text-sm duration-200 bg-gray-800 text-white ring-gray-800 ring-offset-2 hover:ring-2 text-gray-800 rounded-lg"
                        @click="$refs.bankingOverlay.toggle()">Bankverbindungen</button>
                </div>
            </div>
        </div>
    </div>
    <bankingOverlay ref="bankingOverlay"></bankingOverlay>
</template>

<script>
import bankingOverlay from '@/components/bankingOverlay.vue';

export default {
    name: 'Content',
    data() {
        return {
            currentFiles: 5,
            files: [],
            CMS_URL: process.env.VUE_APP_CMS_URL
        }
    },
    components: {
        bankingOverlay
    },
    created() {
        this.getFilesFromCMS();
    },
    methods: {
        async getFilesFromCMS() {
            try {
                let res = await fetch(`${process.env.VUE_APP_CMS_URL}/items/Schmetterling`);
                let json = await res.json();
                this.files = json.data.sort((a, b) => new Date(b['date_created']) > new Date(a['date_created']) ? 1 : -1);
            } catch (e) {
                console.error(e);
            }
        }
    }
}
</script>